import { useEffect, useState } from 'react';
import { Layout, Dropdown, Modal, Avatar, Switch, message, Alert } from 'antd';
import {
  UserOutlined,
  MenuUnfoldOutlined,
  MenuFoldOutlined,
  ExclamationCircleOutlined
} from '@ant-design/icons';
import type { MenuProps } from 'antd';
import dayjs from 'dayjs'
import { useRequest } from "ahooks";
import store from './../../store';
import { toggleSider } from './../../store/action';
import { language } from "./../../locales";
import isBetween from 'dayjs/plugin/isBetween';
import { CommonServer } from "../../server";

import "./index.scss";

const server = CommonServer.Home

dayjs.extend(isBetween);
const { Header: AntdHeader } = Layout;
const { confirm } = Modal;


const lang = language?.config.component.header;
let timer: any = null;

const remindSrc = require('./../../assets/y1897.mp3')

const Header = (props: any) => {
  const [collapsed, setCollapsed] = useState(store.getState().common.siderCollapsed);
  const [userInfo] = useState<any>(JSON.parse(sessionStorage.getItem('userInfo') || '{}'));
  const [remind, setRemind] = useState<boolean>(localStorage.getItem('remind') === 'open');
  const [audio, setAudio] = useState<any>(null);
  const [hasRecharge, setHasRecharge] = useState<boolean>(false);
  const [hasWithdrawal, setHasWithdrawal] = useState<boolean>(false);

  // const currentLanguage = localStorage.getItem('language');

  const { run: refreshRemind } = useRequest(() => Promise.all([
    server.remind({ Type: 10 }),
    server.remind({ Type: 20 }),
  ]), {
    manual: true,
    onSuccess: (res: any) => {
      const isHasRechargeTxt = res[0]?.Count > 0;
      const isHasWithdrawal = res[1]?.Count > 0;

      setHasRecharge(isHasRechargeTxt);
      setHasWithdrawal(isHasWithdrawal);
      if (isHasRechargeTxt || isHasWithdrawal) {
        try {
          audio.play().catch((error: any) => {
            console.error('Error playing audio:', error);
          });
        } catch (error) {
          console.error('Error creating audio:', error);
        }
      }
    }
  });

  const handleUserInteraction = () => {
    const audioInstance = new Audio(remindSrc.default);
    setAudio(audioInstance);
  };

  const loginOut = () => {
    confirm({
      title: '确定退出登录吗？',
      icon: <ExclamationCircleOutlined />,
      onOk() {
        sessionStorage.clear();
        props.history.push("/login");
      }
    });
  }

  const items: MenuProps['items'] = [{
    key: 'loginout',
    label: (
      <span onClick={loginOut}>{lang?.loginOut}</span>
    ),
  }];


  useEffect(() => {
    if (remind) {
      timer = setInterval(() => {
        refreshRemind();
      }, 1000 * 30);
    }
    document.body.click();
    handleUserInteraction();
    return () => {
      clearInterval(timer);
    }
  }, [remind, refreshRemind]);

  return (
    <AntdHeader className="header" style={{ background: '#fff', padding: '0 20px' }}>
      <div className={collapsed ? 'collapsed left' : 'left'}>
        <div className="flex align-center cup toggleIcon" onClick={() => {
          store.dispatch(toggleSider());
          setCollapsed(store.getState().common.siderCollapsed);
        }}>
          {collapsed ? <MenuUnfoldOutlined /> : <MenuFoldOutlined />}
        </div>
      </div>
      <div className="flex align-center cup">

        {/* <Select
          className='mr20'
          popupMatchSelectWidth={false}
          options={[
            {
              label: lang?.cnZH,
              value: 'zh-CN'
            },
            {
              label: lang?.cnTW,
              value: 'zh-TW'
            },
            {
              label: lang?.enUS,
              value: 'en-US'
            },
          ]}
          value={currentLanguage}
          onChange={(v) => {
            localStorage.setItem('language', v);
            window.location.reload();
          }}
        /> */}

        <div className='flex mr20'>
          {hasRecharge ? <Alert className='mr10' message='您有新的充值订单待处理！' type="info" closable
            onClose={() => setHasRecharge(false)}
          /> : null}
          {hasWithdrawal ? <Alert message='您有新的提现订单待处理！'
            type="info" closable onClose={() => setHasWithdrawal(false)} /> : null}
        </div>
        <div className='mr20'>
          <span>充提提醒：</span>
          <Switch className='mr10' checked={remind} onChange={(v) => {
            handleUserInteraction();
            setRemind(v);
            localStorage.setItem('remind', v ? 'open' : 'close')
            if (!v) {
              clearInterval(timer);
              timer = null;
              message.success('已关闭语音提醒！');
            } else {
              message.success('开启语音提醒成功！');
            }
          }} />
        </div>
        <div className='mr20'>{userInfo?.Username}</div>
        <Dropdown menu={{ items }}>
          <Avatar size={48} icon={<UserOutlined />} src={userInfo?.Avatar} />
        </Dropdown>
      </div>
    </AntdHeader>
  );
}

export default Header;